/** Longest expected result, actual result or steps text the feedback endpoint accepts. */
export const FEEDBACK_TEXT_MAX_LENGTH = 5000;

/** Longest document search text `GET /api/feedback/documents` accepts. */
export const DOCUMENT_SEARCH_MAX_LENGTH = 200;

/** Longest page URL the feedback endpoint accepts. */
export const PAGE_URL_MAX_LENGTH = 2048;

/** Longest affected object value the feedback endpoint accepts. */
export const AFFECTED_OBJECT_VALUE_MAX_LENGTH = 200;
